import { useEffect, useState } from "react";

import { parse } from "papaparse";

import "./styles.scss";

interface CsvPreviewProps {
  file: File | undefined;
  highlightColumns?: string[];
  columnNotes?: Record<string, string>;
}

export const CsvPreview = ({ file, highlightColumns, columnNotes }: CsvPreviewProps) => {
  const [fileData, setFileData] = useState<any[]>();
  const [errorMessage, setErrorMessage] = useState<string>();

  useEffect(() => {
    if (file) {
      parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const { data } = results;

          if (data?.length === 0) {
            setErrorMessage("The CSV file is empty.");
            return;
          }

          // TODO: handle errors

          setErrorMessage(undefined);
          setFileData(data);
        },
        error: (error) => {
          // TODO: handle error
          console.log(">>> error: ", error);
        },
      });
    }
  }, [file]);

  if (errorMessage) {
    return <div className="Note">{errorMessage}</div>;
  }

  if (!fileData || fileData.length === 0) {
    return null;
  }

  const dataCols = Object.keys(fileData?.[0]);
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const highlightSet = new Set(highlightColumns ?? []);
  const highlightCell = (index: number) =>
    highlightSet.has(dataCols[index]) ? "CsvPreview__cell--highlight" : "";

  return (
    <div className="CsvPreview">
      <table>
        <thead>
          {/* Row with alphabet letters */}
          <tr>
            {/* Adding extra cell for index */}
            <th></th>
            {dataCols.map((col, index) => {
              const note = columnNotes?.[col];
              return (
                <th
                  key={`col-${col}`}
                  className={highlightCell(index)}
                  title={note}
                >
                  {alphabet.charAt(index)}
                  {note ? <span className="CsvPreview__col-note-indicator">*</span> : null}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {/* Row with column names */}
          <tr>
            {/* Adding extra cell for index */}
            <th>1</th>
            {dataCols.map((col, index) => (
              <td key={`row-${col}`} className={highlightCell(index)}>
                {col}
              </td>
            ))}
          </tr>
          {/* Data rows with index */}
          {fileData.map((item, rowIndex) => (
            <tr key={`row-${rowIndex}`}>
              <th>{rowIndex + 2}</th>
              {Object.values(item).map((val, valIndex) => (
                <td
                  key={`val-${rowIndex}-${valIndex}`}
                  className={highlightCell(valIndex)}
                >{`${val}`}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
